import {Box, Grid} from "@mui/material";

import FilteredDataGrid from "./FilteredDataGrid";
import ModalTrigger from "../Common/ModalTrigger";
import CustomLink from "../Common/CustomLink";
import csv4 from "../../Data/MANCP/Pesticides/MANCP-Results-on-import-control-samples-under-Regulation-2019-1793.csv";

const ImportControl = (props) => {
  return (
    <Grid
     
    >
    </Grid>
  );
};

export default ImportControl;
